import React from "react";
import { Box, Button, Typography, Badge, Tooltip } from "@mui/material";

const InfoBanner = () => {
  const buttonLink = (
    <Button
      variant="gradient"
      type="button"
      href="https://www.trafficjunky.com/sign-up/advertiser?source=Marketing&utm_medium=adsempire&utm_campaign=adsempire_trafficjunky_2025"
      referrerPolicy="no-referrer"
      target="_blank"
      sx={{
        height: {
          xs: 40,
          md: 32,
        },
        minWidth: "fit-content",
        width: "100%",
        textTransform: "capitalize",
        whiteSpace: "nowrap",
        fontSize: "14px",
      }}
    >
      Try now
    </Button>
  );
  return (
    <Box
      sx={{
        borderRadius: {
          xs: 3.75,
          md: "4px",
        },
        backgroundColor: "transparent.light",
        padding: {
          xs: "10px",
          sm: "20px",
          md: "10px",
        },
        marginRight: {
          md: "40px",
        },
        width: {
          xs: "100%",
          md: "fit-content",
        },
      }}
    >
      <Badge
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            md: "row",
          },
          gap: 1,
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            typography: {
              xs: "subtextBold",
            },
            fontSize: {
              sm: "16px",
              lg: "18px",
            },
            fontWeight: {
              sm: "500",
              lg: "700",
            },
            lineHeight: {
              md: "30px",
            },
          }}
        >
          <Box sx={{
            whiteSpace: "nowrap",
            display: {
              xs: "none",
              md: "inline",
            },
          }}>
            Boost Your Campaign
          </Box>
          <Box sx={{
            display: {
              md: "none",
              xs: "inline",
            },
          }}>
            Boost Your First Campaign by doubling your budget Exclusive
            $500 TrafficJunky promo code – only through AdsEmpire.
          </Box>
        </Typography>
        <Box
          sx={{
            width: {
              xs: "100%",
              md: "100px",
            },
          }}
        >
          <Box
            sx={{
              display: {
                xs: "none",
                md: "inline",
              },
            }}
          >
            <Tooltip title="Boost Your First Campaign by doubling your budget Exclusive $500 TrafficJunky promo code – only through AdsEmpire.">
              {buttonLink}
            </Tooltip>
          </Box>
          <Box
            sx={{
              display: {
                md: "none",
                xs: "inline",
              },
            }}
          >
            {buttonLink}
          </Box>

        </Box>
      </Badge>
    </Box>
  );
};

export default InfoBanner;
